export default __webpack_public_path__ + "static/media/O-065.32f16078.png";